import React from 'react';
import { Link } from 'react-router-dom';
import { stateAbbreviations } from '../services/listingHelpers';

const StatesPage: React.FC = () => {
  const grouped = Object.entries(stateAbbreviations).sort((a, b) => a[1].localeCompare(b[1]));

  return (
    <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '40px 20px' }}>
      <h1 style={{ fontSize: '36px', marginBottom: '8px' }}>Browse Rehabs by State</h1>
      <p style={{ color: '#666', marginBottom: '40px', fontSize: '18px' }}>
        Find addiction treatment centers and recovery programs in every state
      </p>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '12px' }}>
        {grouped.map(([abbr, name]) => (
          <Link key={abbr} to={`/search?state=${abbr}`} style={{
            display: 'flex', justifyContent: 'space-between', alignItems: 'center',
            padding: '14px 16px', background: '#fff', borderRadius: '8px',
            textDecoration: 'none', color: '#333', border: '1px solid #e0e0e0',
            transition: 'all 0.2s',
          }}>
            <span style={{ fontWeight: 600 }}>{name}</span>
            <span style={{ fontSize: '12px', color: '#888', background: '#f5f5f5', padding: '2px 6px', borderRadius: '4px' }}>
              {abbr}
            </span>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default StatesPage;
